export default __webpack_public_path__ + "static/media/faq-3.7fb02b8b.png";